
import { Options, Vue } from 'vue-class-component'
import { useStore } from '@/store'

@Options({
})
export default class ServiceControl extends Vue {
  store = useStore()

  restart (): void {
    if (this.store.state.webSocket) {
      this.store.state.webSocket.send(JSON.stringify({
        type: 'restart'
      }))
    }
  }

  start (): void {
    if (this.store.state.webSocket) {
      this.store.state.webSocket.send(JSON.stringify({
        type: 'start'
      }))
    }
  }

  stop (): void {
    if (this.store.state.webSocket) {
      this.store.state.webSocket.send(JSON.stringify({
        type: 'stop'
      }))
    }
  }
}
